// @flow strict
import * as React from 'react'
import { type ContentfulNode } from '@mondough/contentful'
import { getLocalisedFieldsFromNode } from '@mondough/contentful'
import { locale } from '../../Global'
import USAWaitlistSection from '../../components/theme-usa/USAWaitlistSection'
import { usaSubtitleSection } from '../usaThemeComponents'
import { subtitleNodeName } from '@mondough/contentful/src/richTextDecorators'
import USAFeatureChecklist from '../../components/theme-usa/USAFeatureChecklist'

export const renderUSAFeatureChecklist = (node: ContentfulNode) => {
  const { bespokeContent } = getLocalisedFieldsFromNode(node, locale) || {}
  const { title, features } = bespokeContent || {}
  return <USAFeatureChecklist title={title} features={features} />
}

export const renderUSAWaitlist = (node: ContentfulNode) => {
  return (
    <USAWaitlistSection>
      {node[subtitleNodeName] && usaSubtitleSection(node[subtitleNodeName])}
    </USAWaitlistSection>
  )
}
